import React from "react";
import { LastOrderCards } from "presto-react-components";

export default function LastOrderCard(props) {
  return <LastOrderCards.LastOrderCard2 {...props} />;
}
